import adminApiClient from '../../api/base/adminApiClient'

export interface Place {
  id: number
  kakao_place_id: string | null
  /** 카카오 원본 세부 카테고리 (예: "음식점 > 한식 > 한정식") — 표시용 */
  kakao_category?: string | null
  name: string
  category: string
  /** 실제로 앱에 보이는 세부 분류 라벨 (관리자 지정값이 있으면 그 값, 없으면 카카오 원본에서 파싱) */
  sub_category: string | null
  /** 관리자가 직접 지정한 세부 분류. null이면 카카오 원본을 따라가는 중 */
  sub_category_override?: string | null
  /** detail=generic 으로 조회했을 때만 채워진다 */
  reviews_count?: number | null
  lat: string
  lng: string
  address: string | null
  phone_number: string | null
  is_recommended?: boolean
  rating: string | null
  user_ratings_total: number | null
  created_at: string
  updated_at: string
}

export interface GetPlacesResponse {
  data: Place[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetPlacesParams {
  page?: number
  per_page?: number
  search?: string
  /** 'generic' 이면 세부 라벨이 대분류에서 멈춘 장소만 (기록 많은 순) */
  detail?: 'generic'
  /** 기록이 달린 장소만 */
  reviewed_only?: boolean
}

export interface UpdatePlaceParams {
  name: string
  category: string
  lat: string
  lng: string
  address?: string | null
  phone_number?: string | null
  is_recommended?: boolean
  /** 세부 분류 직접 지정. 빈 문자열로 보내면 카카오 원본을 따라간다 */
  sub_category?: string | null
}

export interface UpdatePlaceResponse {
  message: string
  data: Place
}

export const adminPlaceApi = {
  getPlaces: async (params?: GetPlacesParams): Promise<GetPlacesResponse> => {
    const response = await adminApiClient.get<GetPlacesResponse>(
      '/admin/places',
      {
        params,
      }
    )
    return response.data
  },
  updatePlace: async (
    id: number,
    params: UpdatePlaceParams
  ): Promise<UpdatePlaceResponse> => {
    const response = await adminApiClient.put<UpdatePlaceResponse>(
      `/admin/places/${id}`,
      params
    )
    return response.data
  },
  deletePlace: async (id: number): Promise<{ message: string }> => {
    const response = await adminApiClient.delete<{ message: string }>(
      `/admin/places/${id}`
    )
    return response.data
  },
  updatePlaceRecommended: async (
    id: number,
    isRecommended: boolean
  ): Promise<{ message: string; data: { id: number; is_recommended: boolean } }> => {
    const response = await adminApiClient.patch<{
      message: string
      data: { id: number; is_recommended: boolean }
    }>(`/admin/places/${id}/recommended`, { is_recommended: isRecommended })
    return response.data
  },
}
